<template>
  <div>
    <div v-if="groups">
      <div v-for="(lv, index) in groups" :key="lv.key" :ref="`item-${index}`">
        <!-- <van-button @click="scrollToItem(index)">滚动到第{{ index + 1 }}層</van-button> -->
        <!-- {{ gCheckLvData(lv) }} -->
        <!-- <Level :level="lv" @click="s2Click" /> -->
        <Level :level="lv" @click="(item) => {
          s2Click(item, lv, index);
          ;
        }" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.van-col {
  font-size: 0.8rem;
  /* font-weight: bold; */
  color: grey;
}

.el-button {
  font-size: 1rem;
}
</style>

<script>
import Level from "./Level.vue";

export default {
  components: {
    Level,
  },
  props: {
    groups: Array,
  },
  data() {
    return {
      targetItemId: null // 用于 watch 的触发数据
    };
  },
  methods: {
    s2Click(item, lv, index) {
      this.$emit("click", item);
      console.log(lv, index);
      // if (this.gCheckLvData(lv)) { 測試自動滾動
      //   setTimeout(() => {
      //     this.scrollToItem(index + 1);
      //   }, 1000);
      // }
    },
    scrollToItem(itemId) {
      this.targetItemId = itemId; // 触发 watch
    }
  },

  watch: {
    targetItemId(newValue) {
      if (newValue !== null) {
        const element = this.$refs[`item-${newValue}`];
        if (element && element.length > 0) {
          element[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.targetItemId = null; // 重置，防止重复触发
      }
    }
  },
};
</script>
